import i18n from "@/i18n";
import {
  VacancyApplicant,
  VacancyApplication,
} from "../../../model/VacancyApplicant.interface";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import { ActivityApplicationConstants } from "@/apps/tatar/activityApp/ActivityHooks";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import useVacancyApplicantActivityFlow from "../../../action-flow/hooks/useVacancyApplicantActivityFlow";
import moment from "moment";
import LoadOverlay from "@/components/LoadOverlay";
import ModalManager from "@/components/ModalComponent/ModalManager";

type Props = {
  application: VacancyApplication;
  applicant: VacancyApplicant;
  activity: APActivity;
  constants: ActivityApplicationConstants;
};

const VacancyApplicantMissingData = (props: Props) => {
  const { application, applicant, activity, constants } = props;

  const { createRequestApplicantInfoActionFlow, isLoading } =
    useVacancyApplicantActivityFlow({
      activity,
      constants,
    });

  return (
    <div>
      <LoadOverlay open={isLoading} />
      <div>
        {i18n.t(
          "apTemplate:Vacancy.Applicant.Label.DataMissing",
          "Für diesen Bewerber stehen nicht alle Daten zur Verfügung."
        )}
      </div>

      <div>
        {applicant.currentActionFlow?.status === "open" ? (
          <div>
            {i18n.t(
              "apTemplate:Vacancy.Applicant.Label.DataRequested",
              "Daten angefordert am"
            )}{" "}
            {moment(applicant.currentActionFlow.date).format(
              i18n.t("Formats.dateFormat")
            )}
          </div>
        ) : (
          <BFButton
            appearance="link"
            onClick={() => {
              ModalManager.confirm({
                title: i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.RequestData",
                  "Daten anfordern"
                ),
                message: i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.RequestDataMessage",
                  "Möchten Sie die fehlenden Daten anfordern?"
                ),
                confirmButtonText: i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.RequestDataMessageConfirm",
                  "Datenvervollständigung anfordern"
                ),
                onConfirm: () => {
                  createRequestApplicantInfoActionFlow(
                    application,
                    applicant.id
                  );
                },
              });
            }}
          >
            {i18n.t(
              "apTemplate:Vacancy.Applicant.Label.RequestData",
              "Daten anfordern"
            )}
          </BFButton>
        )}
      </div>
    </div>
  );
};

export default VacancyApplicantMissingData;
